

pickerTagListItemController = ($scope, $element, tagClassFilter) ->
    'ngInject'
    @tagPicker = $element.controller('dybTagPicker')

    $element.addClass(tagClassFilter(@tag).join(' '))

    $element.on 'mouseenter', => $scope.$apply =>
        @tagPicker.hoverItem(@tag)
        return

    $element.on 'click', => $scope.$apply =>
        @tag.select()
        return

    $scope.$on 'tagpicker:activeItemChanged', (event, item) =>
        $element.toggleClass('active', @tag == item)
        return

    return

pickerTagListItemDirective = ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'util/tags/pickerTagListItem'
    scope: tag: '='
    require: '^dybTagpickerTagList'
    controller: pickerTagListItemController
    bindToController: true
    controllerAs: 'ctrl'

module.directive 'dybTagpickerTagListItem', pickerTagListItemDirective